<template>
  <v-list-item>
    <v-list-item-icon>
      <v-icon>mdi-apps</v-icon>
    </v-list-item-icon>

    <v-list-item-content >
      <!-- <v-menu v-model="showApps" offset-y left> -->
      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-list-item-title
            v-bind="attrs"
            v-on="on"
            style="cursor: pointer"
          >
            Apps relacionadas
          </v-list-item-title>
        </template>

        <v-card width="270">
          <v-row no-gutters class="pt-2 pr-2 pl-2">
            <v-col cols="4" class="pa-2 related-app" @click="openApp('https://tools.arditec.es/login')">
              <div class="imgMenu">
                <v-img src="/svgRelatedApps/arditec-logo.ico"/>
              </div>
              <v-card-text class="textMenu">Contraseñas</v-card-text>
            </v-col>

            <v-col cols="4" class="pa-2 related-app" @click="openApp('https://toctoc.arditec.es/login')">
              <div class="imgMenu">
                <v-img src="/svgRelatedApps/arditec-logo.ico" />
              </div>
              <v-card-text class="textMenu">Toc Toc</v-card-text>
            </v-col>

            <v-col cols="4" class="pa-2 related-app" @click="openApp('https://ticket.arditec.es/scp/login.php')">
              <div class="imgMenu">
                <v-img src="/svgRelatedApps/osTicket.svg"/>
              </div>
              <v-card-text class="textMenu">OsTicket</v-card-text>
            </v-col>
          </v-row>

          <v-row no-gutters class="pb-2 pl-2">
            <v-col cols="4" class="pa-1 related-app" @click="openApp('https://app.clickup.com/login')">
              <div class="imgMenu">
                <v-img src="/svgRelatedApps/clickUp.svg"/>
              </div>
              <v-card-text class="textMenu">ClickUp</v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-menu>
    </v-list-item-content>
  </v-list-item>
</template>


<script>
export default {
  name: 'RelatedApps',
  methods: {
    openApp(link) {
      window.open(link, '_blank');
    }
  }
};
</script>
<style>
    .imgMenu {
        width: 35px;
        height: 35px;
        border: 1px solid #ccc;
        border-radius: 20%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 4px;
        padding: 4px;
    }

    .textMenu {
        font-size: 12px !important;
        text-align: center;
        padding: 0 !important;              
        margin: 0;              
    }

    .related-app {
        cursor: pointer;
    }
</style>
